var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificationServiceBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 264,
    viewBox: "0 0 238 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2021_596)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1885 46.9605L42.2285 96.427C44.5783 102.532 50.6133 106.41 57.1426 106.011L80.5586 104.579L91.1108 131.366L139.093 123.927L104.051 56.4746L103.466 57.4238L85.5517 22.6494L23.1885 46.9605Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.487 144.265C197.275 126.971 181.346 115.135 163.283 115.135H28.0158C14.2913 115.135 4.45377 128.374 8.41402 141.515L39.9028 246C42.5089 254.648 50.4733 260.566 59.5047 260.566H209.984C223.709 260.566 233.546 247.326 229.586 234.186L202.487 144.265Z",
    fill: "#2B374E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8869 249.602L78.9841 235.383C82.998 233.109 87.6311 232.17 92.2137 232.702L133.864 237.534L133.864 252.359L123.787 251.203L112.662 252.89C104.543 254.121 96.2416 253.029 88.7174 249.74L85.2661 248.231C82.3828 246.971 79.1363 246.817 76.1468 247.8L57.8266 253.82C56.6637 254.202 55.407 254.188 54.2532 253.779C52.3912 253.119 52.1681 250.576 53.8869 249.602Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7618 117.454L49.9251 107.519C45.9881 105.944 42.8012 102.926 41.0156 99.0796L35.955 88.1798C35.3483 86.8732 34.2299 85.8745 32.8633 85.419C30.1716 84.5217 27.5008 86.8328 28.0021 89.6255L30.3142 102.507C31.1475 107.15 33.9126 111.22 37.9214 113.706L60.719 127.84C63.7278 129.706 65.8292 132.734 66.5235 136.206L70.1689 154.433H91.1323L86.4392 131.436C85.1476 125.107 80.7591 119.853 74.7618 117.454Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.999 59.5889L42.999 66.5889",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.999 59.5889L42.999 66.5889",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.999 59.5889L42.999 66.5889",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.999 52.5889L64.999 59.5889",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.999 52.5889L64.999 59.5889",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.999 52.5889L64.999 59.5889",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3598 61.2307L105.108 56.7891L90.7193 17.6336C87.3254 8.3981 77.1445 3.59917 67.8608 6.85888L29.1568 20.4486C21.0356 23.3001 16.9746 32.386 20.2667 40.3388L23.6289 48.4608L66.999 33.0889L74.4553 49.6036L78.5028 48.4608C77.9485 46.2401 78.3919 41.1324 84.5999 38.4679C94.7987 34.4705 94.0227 51.9775 92.3598 61.2307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.714 59.002C151.782 50.5254 154.038 47.8594 158.14 45.3301C161.079 43.416 163.335 41.2969 163.335 38.1523C163.335 34.7344 160.669 32.4785 157.388 32.4785C154.175 32.4785 151.235 34.5977 151.099 38.6309H141.392C141.597 28.9922 148.706 24.4121 157.456 24.4121C166.958 24.4121 173.726 29.4023 173.726 37.8105C173.726 43.416 170.854 47.0391 166.343 49.7051C162.515 52.0293 160.806 54.2168 160.737 59.002V59.7539H151.714V59.002ZM156.431 75.2031C153.218 75.2031 150.62 72.6055 150.688 69.4609C150.62 66.3164 153.218 63.7871 156.431 63.7871C159.438 63.7871 162.104 66.3164 162.104 69.4609C162.104 72.6055 159.438 75.2031 156.431 75.2031Z",
    fill: "#3A7EFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237.072,
    height: 262.208,
    fill: "white",
    transform: "translate(0.463867 0.981445)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificationServiceBody);
export default __webpack_public_path__ + "static/media/IcCertificationServiceBody.b0edf64fa5681635c5791d49baa25656.svg";
export { ForwardRef as ReactComponent };